<template>
  <div class="companywrap" style="min-height: 700px;">
    <div class="choosewrap">
      <div class="choosebtn" @click="chooseShow">{{$t('exhibitor.filter')}}</div>
      <el-input
        prefix-icon="el-icon-search"
        :placeholder="placeholder"
        v-model="keywords"
        clearable>
      </el-input>
      <div class="search"  @click="search">{{$t('exhibitor.searchProduct')}}</div>
      <div class="moblie-filter" @click="chooseShow"><img src="../../../assets/screen.png" alt="" srcset="">{{$t('exhibitor.filter')}}</div>
    </div>
    <Swiper :options="swiperOption"  class="product-swiper-container swiper-container">
      <SwiperSlide class="swiper-wrapper">
        <div :class="[current == -1 ? 'active' : '']" @click="changeNav(-1)">{{$t('exhibitor.all')}}</div>
      </SwiperSlide>
      <SwiperSlide class="swiper-wrapper" v-for="(item, index) in navList" :key="index">
        <div v-if="langSet == 'zh' || item.description.length == 0" :class="[current == index ? 'active' : '']" @click="changeNav(index,item.linkageid)">{{item.name}}</div>
        <div v-if="langSet == 'en' && item.description.length > 0" :class="[current == index ? 'active' : '']" @click="changeNav(index,item.linkageid)">{{item.description}}</div>
      </SwiperSlide>
    </Swiper>
    <div class="pro-item-wrap" v-if="list.length > 0">
        <div class="pro-item" v-for="item in list" :key="item.id" @click="toDetail(item.id)">
            <div class="pro-list">
                <img v-if="item.img" :src="$imgUrl + item.img" alt=""  /> 
                <p v-if="langSet == 'zh' || item.en_goodsName.length == 0" class="pro-title">{{item.goodsName}}</p>
                <p v-if="langSet == 'en' && item.en_goodsName.length > 0" class="pro-title">{{item.en_goodsName}}</p>
                <p v-if="langSet == 'zh' || item.enCompanyName.length == 0" class="pro-company">{{item.companyName}}</p>
                <p v-if="langSet == 'en' && item.enCompanyName.length > 0" class="pro-company">{{item.enCompanyName}}</p>
            </div>
        </div>
    </div>
    <el-pagination
        background
        v-if="list.length > 0"
        :page-size = pagesize
        @current-change="changePage"
        layout="total,prev, pager, next"
        :total="total">
    </el-pagination>
    <div class="maskwrap" v-if="isShow">
      <div class="maskmain">
        <div class="el-icon-close" @click="closeChoose" style="font-size: 40px;cursor: pointer;"></div>
        <div class="masklist">
          <p class="masktitle">{{$t('exhibitor.productGroups')}}</p>
          <div :class="[productid == item.linkageid ? 'select' : '', 'masklabel', 'productlabel']" v-for="(item, index) in productType" :key="index" @click="choosePList(item.linkageid)">
            <span>
                <b v-if="langSet == 'zh' || item.description.length == 0">{{item.name}}</b>
                <b v-if="langSet == 'en' && item.description.length > 0">{{item.description}}</b>
                <i v-if="item.child.length > 0 && productid == item.linkageid" class="el-icon-arrow-down"></i>
                <i v-if="item.child.length > 0 && productid != item.linkageid" class="el-icon-plus"></i>
            </span>
            <div class="submasknav" v-if="item.child.length > 0">
              <i class="el-icon-caret-top"></i>
              <p v-for="(_item,_index) in item.child" :key="_index" >
                <span v-if="langSet == 'zh' || _item.description.length == 0" :class="[subMenuid == _item.linkageid ? 'active' : '']" @click.stop="levelClick(_item.linkageid)">{{_item.name}}</span>
                <span v-if="langSet == 'en' && _item.description.length > 0" :class="[subMenuid == _item.linkageid ? 'active' : '']" @click.stop="levelClick(_item.linkageid)">{{_item.description}}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="maskbtn">
          <span class="reset" @click="reset">{{$t('exhibitor.reset')}}</span>
          <span @click="searchBtn">{{$t('exhibitor.searchresult')}}</span>
        </div>
      </div>
    </div>
    <div class="nodata" style="padding:100px 0;" v-if="list.length == 0">
      <img v-if="langSet == 'zh'" src="../../../assets/nodata.png" alt="">
      <img v-else src="../../../assets/nodata01.png" alt="">
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { getProductList, getAll } from "@/api/api";
export default {
  components: { Swiper, SwiperSlide},
  data() {
    return {
      input: '',
      isShow: false,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: true,
      },
      navList:[],
      current: -1,
      col: 4,
      list: [],
      keywords: '',
      companyid:'',
      page: '1',
      pagesize: 20,
      productClass_1:'',
      productClass_2:'',
      total: 0,
      productType: [],
      productid: -1,
      subMenuid: -1,
      langSet: '',
      placeholder: ''
    };
  },
  created() { 
  },
  mounted() {
    this.langSet = localStorage.getItem('languageSet') || 'zh';
    this.placeholder = this.$t('exhibitor.placeholderProduct');
    this.memberid = localStorage.getItem('memberid');
    this.getList();
    let nav = this.$qs.stringify({
      keyid: "3407"
    })
    this.getNav(nav)
  },
  methods: {
    chooseShow(){
      this.isShow = true;
      //筛选类型    
      this.getAllList(3407);
    },
    closeChoose(){
      this.isShow = false;
    },
    changeNav(index,id){
      this.current = index;
      this.productClass_1= id;
      this.getList();
    },
    search(){
      //console.log(this.keywords)
      if(this.keywords == 0){
        this.$message('请输入产品名称');
        return false;
      }
      this.getList();
    },
    getNav(data){
      getAll(data).then(res=>{
        //console.log(res)
        if(res.data.errno == 0){
          this.navList = res.data.rst.data
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getList(){
      let data = this.$qs.stringify({
        keywords: this.keywords,
        memberid: this.memberid,
        companyid: this.companyid,
        productClass_1: this.productClass_1,
        productClass_2: this.productClass_2,
        pagesize: this.pagesize,
        page: this.page
      })
      //console.log(data)
      getProductList(data).then(res=>{
        console.log(res.data)
        if(res.data.errno == 0){
          this.list = res.data.rst;
          this.total = Number(res.data.errmsg);
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getAllList(keyid){
      let data = this.$qs.stringify({
        keyid
      })
      console.log(data)
      getAll(data).then(res=>{
        //console.log(res.data.rst.data)
        if(res.data.errno == 0){
          this.productType = res.data.rst.data;
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    changePage(val){
      this.page = val;
      let data = this.$qs.stringify({
        keywords: this.keywords,
        memberid: this.memberid,
        companyid: this.companyid,
        productClass_1: this.productClass_1,
        productClass_2: this.productClass_2,
        pagesize: this.pagesize,
        page: this.page
      })
      this.getList(data)
    },
    toDetail(id){
      //console.log(id)
      this.$router.push({
        name:"prodetail",
        query:{id}
      });
    },
    choosePList(id){
      if(this.productid != id){
        this.productid = id;
      }else{
        this.productid = -1;
      }
    },
    levelClick(id){
      if(this.subMenuid != id){
        this.subMenuid = id;
      }else{
        this.subMenuid = -1;
      }
    },
    reset(){
      this.productid = -1;
      this.subMenuid = -1;
    },
    searchBtn(){
      this.current = -1;
      this.isShow = false;
      this.productClass_1 = this.productid;
      this.productClass_2 = this.subMenuid;
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.product-swiper-container{line-height: 46px;height: 46px;margin:19px 0 16px;}
.product-swiper-container .swiper-slide{width: auto;padding-right: 45px;color: #666;font-size: 22px;}
.product-swiper-container .swiper-slide .active{font-size: 24px;color: #CAC28A;}

.pro-item-wrap{column-count: 4;column-gap: 10;margin-bottom: 25px;min-height: 500px;}
.pro-item{width: 100%;margin-bottom: 25px;cursor: pointer;break-inside:avoid;}
.pro-item img{width: 100%;border-radius:20px;}
.pro-item .pro-title{font-size:16px;color: #000;font-weight:600;line-height:24px;}
.pro-item .pro-company{font-size:14px;color: #999;line-height:18px;}

.maskwrap{position: fixed;width: 100%;height: 100%;top: 0;left: 0;background:rgba(0,0,0,.5);z-index: 99;}
.maskmain{width:800px;background: #fff;padding:27px 50px 77px;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);box-sizing: border-box;height: 70%;overflow-y: scroll;}
.maskmain .masktitle{font-size:24px;font-weight: 600;line-height: 33px;}
.masklist{margin-bottom: 50px;padding: 0 20px;}
.masklist .masklabel span{background:rgba(238,238,238,1);border-radius:4px;display: inline-block;padding: 5px 10px;font-size:18px;color: #000;cursor: pointer;margin: 10px 10px 0 0;}
.masklist .masklabel span.active{background:#CAC28A;color: #fff;}
.maskbtn{display: flex;justify-content: center;}
.maskbtn span{display: inline-block;cursor: pointer;width:153px;height:40px;text-align: center;line-height: 40px;font-size: 18px;color: #fff;background:#CAC28A;border-radius:3px;}
.masklist .masklabel span > i{font-size: 14px;position: relative;top: -2px;}
.maskbtn span.reset{background:#CAC28A;color: #000;margin-right: 26px;}
.productlabel{display: inline-block;}
.productlabel.select > span{background:#CAC28A;color: #fff;}
.productlabel.select .submasknav{display: flex;flex-wrap: wrap;}
.submasknav{display: none;background: #FFF2F2;padding: 10px 10px 20px 10px;margin-top: 16px;position: relative;width: 700px;}
.submasknav i{position: absolute;top: -15px;color: #fff2f2;font-size: 22px;}
.masklist .masklabel .submasknav span{background: #fff;cursor: pointer;}
.masklist .masklabel .submasknav span.active{background: #CAC28A;color: #fff;}
.moblie-filter{display: none;}
@media only screen and (max-width: 767px){
  .pro-item-wrap{column-count:2;margin-top: 0.2rem;}
  .pro-item{width: 100%;margin-bottom: 0.25rem}
  .product-swiper-container .swiper-slide{font-size: 18px;padding-right: 0.2rem;}
  .product-swiper-container .swiper-slide .active{font-size: 20px;}
  .companyWrap {
    margin-top: 0.36rem;
  }
  .product-swiper-container{display: none;}
  // 分页
  .companywrap .el-pagination{padding: 0.05rem;height: 0.5rem;}
  .companywrap .el-pagination button, .companywrap .el-pagination span:not([class*=suffix]),
  .companywrap .el-pager li{font-size: 12px;}
  .companywrap .el-pagination button, .companywrap .el-pagination span:not([class*=suffix]){height: 0.36rem;line-height: 0.4rem;}
  .companywrap .el-pagination.is-background .el-pager li{width: 0.4rem;height: 0.4rem;line-height: 0.4rem;}
  .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{min-width: 0;margin: 0 0.03rem;}
  .companywrap .el-pagination .btn-next .el-icon, .companywrap .el-pagination .btn-prev .el-icon{font-size: 12px;line-height: 0.4rem;}
  .el-pagination button, .el-pagination span:not([class*=suffix]){margin-right: 0;}
  // 分页
  .companylist{
    padding:10px 15px;
    background:#fff;
    border:0 none;
    box-shadow:0px 1px 8px 0px rgba(0,0,0,0.15);
    border-radius:10px;
    .logo{width: 0.98rem;height: 0.98rem;border:0 none;}
    .middle{
      padding-left: 0.2rem;
      p{
        font-size: 12px;
      }
      .title{font-size: 14px;line-height: 18px;}
    }
    .right{
      display: none;
    }
  }
  .maskmain{
    width: 80%;height: 60%;overflow-y: scroll;padding:0.2rem;border-radius: 10px;
    .el-icon-close{
      font-size: 30px !important;
      display: block;
      text-align: right;
    }
    .masktitle{font-size: 16px;}
    .masklist{
      margin-bottom: 0.5rem;
      .masklabel {
        span{
          font-size: 14px;
        }
      }
    }
    .maskbtn span{width: 2rem;}
  }
  .submasknav{width: 95%;}
  .choosewrap{
    .choosebtn,.search{display: none;}
    .el-input{width: 3rem;}
    .el-input__inner{
      width: 3rem;
      height: 0.6rem;
      font-size: 12px;
    }
    .el-input__icon{font-size: 16px;line-height: 0.6rem;}
    .el-input__prefix{left: 0;}
    .el-input--prefix .el-input__inner{padding-left: 0.4rem;padding-right: 0.1rem;}
  } 
  .moblie-filter{
    display: block;
    flex: 1;
    font-size: 12px;
    color: #303030;
    text-align: right;
    line-height: 0.6rem;
    img{
      width: 0.28rem;
      margin-right: 0.1rem;
      position: relative;
      top: 0.05rem;
    }
  }
}
</style>